/*
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 */

export interface IResponseErrorOptions {
  parameter?: string;
}

export class ResponseError extends Error {
  private _options?: IResponseErrorOptions;

  constructor(message?: string, options?: IResponseErrorOptions) {
    super(message);
    this._options = options;
  }

  get parameter(): string | undefined {
    return this._options?.parameter;
  }
}
